import React from "react";
import { connect } from "react-redux";

import bindActions from "../../../../helpers/bindActions";
import * as chartSideMedicalFillInFormActions from "../../../../actions/chartSideMedicalFillInFormActions";
import * as simpleModalActions from "../../../../actions/simpleModalActions";
import exitBlackImage from "../../../../assets/images/chart/ic_fullscreen_exit_black_24dp_1x.png";
import exitImage from "../../../../assets/images/chart/ic_fullscreen_black_24dp_1x.png";
import { SidebarHeader, SidebarHeaderType } from "../../../sidebar/SidebarHeader";
import MedicalFormsTextAreaForm from "./MedicalFormsTextAreaForm";

const enhancer = connect(
  ({ chartSideMedicalFillInForm }) => ({ chartSideMedicalFillInForm }),
  bindActions({ chartSideMedicalFillInFormActions, simpleModalActions }),
);
export default enhancer(
  class MedicalFormsTextArea extends React.Component {
    componentDidMount() {
      if (!this.props.edit) {
        this.props.chartSideMedicalFillInFormActions.initTextarea();
      }
    }
    render() {
      const {
        edit,
        chartSideMedicalFillInForm: { item, fullScreen },
        chartSideMedicalFillInFormActions,
        simpleModalActions,
      } = this.props;

      return (
        <div className="chart-clinical-note">
          <div className="clinical-note-item clinical-note-item-slime">
            <SidebarHeader
              buttonWidth={115}
              type={SidebarHeaderType.Secondary}
              rightComponent={
                <div className="d-flex align-items-center pr-2 justify-content-between">
                  <span>#{item.patient && item.patient.chartNumber}</span>
                  <button
                    type="button"
                    title="full screen"
                    onClick={() => chartSideMedicalFillInFormActions.fullScreen(!fullScreen)}
                    className="pull-right btn-link"
                  >
                    <img src={fullScreen ? exitBlackImage : exitImage} alt="" />
                  </button>
                </div>
              }
              title="ADD MEDICAL FORM"
              onBackClick={() => {
                simpleModalActions.openSimpleModal({
                  body: "Do you want to save your changes?",
                  footer: (
                    <div className="text-right">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          simpleModalActions.closeSimpleModal();
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          chartSideMedicalFillInFormActions.setMedicalFillInFormAddendumId(0);
                          simpleModalActions.closeSimpleModal();
                          chartSideMedicalFillInFormActions.openTextarea(false);
                        }}
                      >
                        No
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          chartSideMedicalFillInFormActions.setMedicalFillInFormAddendumId(0);
                          simpleModalActions.closeSimpleModal();
                          chartSideMedicalFillInFormActions.submitTextareaForm();
                        }}
                      >
                        Yes
                      </button>
                    </div>
                  ),
                });
              }}
            />
            <div className="clinical-note-item-edit-body">
              <MedicalFormsTextAreaForm
                changeCreatedDate={this.props.chartSideMedicalFillInFormActions.changeCreatedDate}
                onSubmit={this.props.chartSideMedicalFillInFormActions.submitTextareaForm}
                item={item}
                edit={edit}
              />
            </div>
          </div>
        </div>
      );
    }
  },
);
